import React, { useState } from "react";
import "./FlipCard.css";

function FlipCard({ title, description }) {
  const [flipped, setFlipped] = useState(false);

  const toggleFlip = () => setFlipped((prev) => !prev);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggleFlip();
    }
  };

  return (
    <div
      className={`flip-card ${flipped ? "flipped" : ""}`}
      onClick={toggleFlip}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-pressed={flipped}
      aria-label={`Tarjeta ${title}. ${flipped ? "Vista posterior" : "Vista frontal"}`}
    >
      <div className="flip-card-inner">
        <div className="flip-card-front">
          <h4>{title}</h4>
        </div>
        <div className="flip-card-back">
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
}

export default FlipCard;
